import type { FaireProductEntity } from "../../entity_types/product";

export const p_7sykb7ga5v: FaireProductEntity = {
  token: "p_7sykb7ga5v",
  type: "product",
  name: "Banana Squishy Fidget Toy Stress Relief",
  brandToken: "b_72ivqmkinu",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/c5dd37c0e6fa521797cba7b49f674565807c27fb879363b0aeeb5e5135f8805f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e54ca03d600112b26eba08fdbc1dfb06678ee6d419dea2deeed162071a115119.png",
  ],
  priceDollars: 2.99,
  description:
    "A banana-shaped squishy toy with a soft, stretchy texture and cute character face. Great for sensory play, stress relief, fidget toys, novelty gifts, party favors, and counter displays.\n\nKey Features\nDisplay box includes banana-shaped squishy toys with cute smiling face details.\nSoft and stretchy texture offers a satisfying squeeze, pull, and rub feel.\nEach piece is individually wrapped for clean retail presentation.\nFruit-inspired design creates strong impulse-buy appeal for kids and gift shoppers.\nGreat for toy stores, gift shops, party favors, and trending sensory toy collections.\n\nPrice on Faire is per Piece; case pack includes 12 pieces.",
  tags: [],
  msrpDollars: 7.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:39.400Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
